import { type BuiltInView, TIMECARD_VIEWS } from 'components/tables/list-table/filter-bar/builtInViews';
import { useHasPermissions } from 'utils/permissionUtil';

/** Under READ.TIMECARDS.DRAFT.ALL the DRAFT view lists every employee's drafts, so its label drops "My". */
const ALL_DRAFTS_VIEWS: BuiltInView[] = TIMECARD_VIEWS.map((view) =>
    view.id === 'draft' ? { ...view, labelId: 'timecards.tabs.all-drafts' } : view
);

/** The timecard list's built-in views, labelled for what the user's DRAFT view lists. */
export const useTimecardViews = (): BuiltInView[] =>
    useHasPermissions(['READ.TIMECARDS.DRAFT.ALL']) ? ALL_DRAFTS_VIEWS : TIMECARD_VIEWS;
